import * as React from 'react';

import { Dialog, DialogContentText, DialogContent, DialogActions, Button, DialogTitle, Typography } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
//import { AppBar, Toolbar, Typography } from '@material-ui/core';

import { Trans, WithTranslation, TransProps, withTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { AppState } from '../../appredux';
import { Fragment } from 'react';

interface AppProps {
  page?: any,
  open: boolean,
  close: () => void,
  dialogContent: any
}

class DialogError extends React.Component<AppProps & WithTranslation & TransProps & WithStyles<typeof styles>> {
//   constructor(props: AppProps) {
//     super(props, {});
//   }


  close = () => {
    this.props.close();
  }

  //PM 2021-08-05
  render() {
    const {classes, t} = this.props;

    return (
        <Dialog
            disableEscapeKeyDown
            maxWidth="sm"
            open={this.props.open}
            //fullWidth
        >
            <DialogTitle disableTypography style={{ minWidth: "280px" }}>
                <Typography variant="h6" component="h2" color="error">
                    <b>{t('Warning')}</b>
                </Typography>
                <hr />
            </DialogTitle>
            <DialogContent >
                {this.props.dialogContent.map((text: any) => (
                    <Fragment key={`${text.message} * ${text.messageBoldPrimary}`}>
                        <DialogContentText  style={{ paddingLeft: text.message.includes("*") ? "12px" : "0", minHeight: "24px" }}>
                            {text.message}
                            {text.messageBoldPrimary ?
                                <b className={classes.primary}>{text.messageBoldPrimary}</b> : null}
                        </DialogContentText>
                        
                    </Fragment>
                )) }

            </DialogContent >
            <DialogActions >

                <Button onClick={() => this.close()} variant="outlined" size="small" color="secondary"
                    style={{ textTransform: "none", fontSize: "0.8rem" }}
                >
                    <b><Trans>OK</Trans></b>
                </Button>
            </DialogActions>
        </Dialog>
    );
  }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default withStyles(styles)(connect(mapStateToProps)(withTranslation()(DialogError)));
